import { AmenitiesTypeEnum, AmenityInterface } from '../../..';

export class UpdateAmenityRequestDto implements AmenityInterface {
  iconKey: string;
  type: AmenitiesTypeEnum;
}
